export const envNames = {
    LOCAL: "local",
    DEV: "dev",
    QA: "qat",
    STAGING: "stg",
    PROD: "prod",
};

export const apiPaths = {
    [envNames.LOCAL]: "http://localhost:3000",
    [envNames.DEV]: "https://graphqlsvc-isp.int.dmd.disney.com",
    [envNames.QA]: "https://graphqlsvc-isp.qat.dmd.disney.com",
    [envNames.STAGING]: "https://graphqlsvc-isp.stg.dmd.disney.com",
    [envNames.PROD]: "https://graphqlsvc-isp.dmd.disney.com",
};
